var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgUnarchiveFilled = function SvgUnarchiveFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    d: "M21 5.5H3c-.552 0-1-.28-1-.625v-1.25C2 3.28 2.448 3 3 3h18c.552 0 1 .28 1 .625v1.25c0 .345-.448.625-1 .625Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M20.667 7v12a2 2 0 0 1-2 2H5.333a2 2 0 0 1-2-2V7h17.334Zm-8.137 4.47a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 1 0 1.06 1.06l.72-.72v2.54a.75.75 0 0 0 1.5 0v-2.54l.72.72a.75.75 0 1 0 1.06-1.06l-2-2Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUnarchiveFilled);
export default ForwardRef;